import { Box, SxProps } from '@mui/material'
import React from 'react'

type Props = {
  children: React.ReactNode
  sx?: SxProps
}

// Shared "white surface" used by detail pages to reduce visual noise and harmonize spacing.
export const DetailSurface: React.FC<Props> = ({ children, sx }) => {
  return (
    <Box
      sx={{
        width: '100%',
        maxWidth: '1200px',
        mx: 'auto',
        my: { xs: 1.5, md: 2 },
        px: { xs: 1.5, sm: 2.5 },
        py: { xs: 1.5, sm: 2 },
        backgroundColor: 'white',
        border: '1px solid #E4E8F2',
        borderRadius: 5,
        boxShadow: '0 1px 2px rgba(32, 56, 100, 0.04)',
        boxSizing: 'border-box',
        ...sx,
      }}
    >
      {children}
    </Box>
  )
}
